<template>
  <div class="SetMeal">
    <div class="bottomChoose solveBfc">
      <!-- <div class="allocationBox">
        <div class="allocationItem">
          <img class="allocationIcon" src="@/assets/icons/memory.png" alt="" />
          <div>{{ getAllocationObj(modelActive).memory }}</div>
        </div>
        <div class="allocationItem">
          <img
            class="allocationIcon"
            src="@/assets/icons/stockpile.png"
            alt=""
          />
          <div>{{ getAllocationObj(modelActive).stockpile }}</div>
        </div>
      </div> -->
      <div class="versionBox">
        <div class="versionTitle">型号选择</div>
        <div class="versionButBox">
          <div
            :class="['versionBut', index == supplierActive ? 'active' : '']"
            v-for="(item, index) in versionList"
            :key="index"
            @click="supplierChange(index)"
          >
            {{ item.alias }}
          </div>
        </div>
      </div>
      <div class="versionBox">
        <div class="versionTitle">版本选择</div>
        <div class="versionButBox">
          <div
            :class="['versionBut', index == versionsActive ? 'active' : '']"
            v-for="(item, index) in versionList[supplierActive]
              .productVersionVos"
            :key="index"
            @click="versionsChange(index)"
          >
            {{ item.deviceVersionName }}
          </div>
        </div>
      </div>
      <div class="commodityBox solveBfc">
        <div
          v-for="(item, index) in visibleItems(
            versionList[supplierActive].productVersionVos[versionsActive]
              .packageList
          )"
          :key="index"
          :class="[
            'commodityItem',
            index == commodityActive ? 'commodity_active' : '',
          ]"
          @click="commodityChange(index)"
        >
          <div
            :class="[
              item.promotionName == '首充优惠' ? 'peculiarMark' : 'cornerMark',
            ]"
            v-if="item.promotionName != '正常销售'"
          >
            {{ item.promotionName }}
          </div>
          <div class="commodityLeft">
            <div class="packageName">{{ item.packageName }}</div>
            <div class="promotionDescription">
              {{
                item.promotionDescription
                  ? item.promotionDescription == "批量优惠"
                    ? `批量购买最低${item.salePrice}元/台`
                    : item.promotionDescription
                  : ` ¥ ${item.avgPrice.toFixed(2)} /天`
              }}
            </div>
          </div>
          <div class="commodityRight">
            <div class="salePrice">
              <div class="span1">¥</div>
              <div class="span2">{{ item.salePrice.toFixed(2) }}</div>
            </div>
            <div class="avgPrice">
              {{ ` ¥ ${item.avgPrice.toFixed(2)} /天` }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="moreBox"
      v-if="
        versionList[supplierActive].productVersionVos[versionsActive]
          .packageList.length > intCount
      "
    >
      <div class="more" @click="handleMore(0)" v-if="!showAll">
        <div class="name">更多套餐</div>
        <img class="icon" src="@/assets/icons/direction_right.png" alt="" />
      </div>
      <div class="getBack" @click="handleMore(1)" v-if="showAll">
        <img class="icon" src="@/assets/icons/direction_left.png" alt="" />
        <div class="name">返回</div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import buyCode from "@/utils/buyCode";
export default {
  name: "SetMeal",
  props: {
    modelActive: {
      type: Number,
      default: 0,
    },
    supplierActive: {
      type: Number,
      default: 0,
    },
    versionsActive: {
      type: Number,
      default: 0,
    },
    commodityActive: {
      type: Number,
      default: 0,
    },
    intCount: {
      type: Number,
      default: 0,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    versionList: {
      type: Array,
      default: [{ productVersionVos: [] }],
    },
  },
  data() {
    return {
      allocationOptions: [
        {
          memory: "3.6运存",
          speedUp: "8核",
          stockpile: "44G总储存",
          value: "0",
        },
      ],
    };
  },

  mounted() {
    this.allocationOptions = buyCode.allocationOptions;
  },
  computed: {
    getAllocationObj: {
      get() {
        return function (status) {
          let item = this.allocationOptions.find(
            (item) => item.value == status
          );
          if (item) {
            return item;
          }
        };
      },
    },
    visibleItems: {
      get() {
        return function (list) {
          return this.showAll
            ? list.slice(this.intCount, list.lenght)
            : list.slice(0, this.intCount);
        };
      },
    },
  },

  methods: {
    supplierChange(index) {
      this.$emit("supplierChange", index);
    },
    versionsChange(index) {
      this.$emit("versionsChange", index);
    },
    commodityChange(index) {
      this.$emit("commodityChange", index);
    },
    handleMore(type) {
      this.$emit("handleMore", type);
    },
  },
};
</script>
    
    <style lang="less" scoped>
.SetMeal {
  .bottomChoose {
    width: 100%;
    background: #ffffff;
    border-radius: 0px 0px 13px 13px;
    padding: 0px 13px 13px 13px;
    .allocationBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .allocationItem {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .allocationIcon {
          width: 23px;
          height: 23px;
          margin-right: 8px;
        }
      }
    }
    .versionBox {
      margin-top: 21px;
      .versionTitle {
        font-weight: 600;
        font-size: 15px;
        color: #67686e;
        text-align: left;
      }
      .versionTitleMtop {
        margin-top: 16px;
      }
      .versionButBox {
        display: flex;
        flex-wrap: wrap;
        .specialBut {
          position: relative;
          overflow: hidden;
        }
        .versionBut {
          height: 33px;
          line-height: 33px;
          background: #f5f7fb;
          border-radius: 8px;
          font-weight: bold;
          font-size: 10px;
          color: #999ca7;
          padding: 0 17px;
          margin-right: 8px;
          margin-top: 12px;
        }
        .active {
          background: #eeedff;
          color: #886df3;
        }
      }
    }
    .commodityBox {
      margin-top: 12px;
      .commodityItem {
        width: 100%;
        height: 73px;
        background: #f5f7fb;
        border-radius: 10px;
        position: relative;
        margin-top: 13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;
        .cornerMark {
          position: absolute;
          left: 0;
          top: -5px;
          padding: 2px 8px;
          background: #e9e3ff;
          border-radius: 8px 0px 8px 0px;
          font-weight: 600;
          font-size: 10px;
          color: #a092eb;
        }
        .peculiarMark {
          position: absolute;
          left: 0;
          top: -5px;
          padding: 2px 8px;
          background: #f96d6f;
          border-radius: 8px 0px 8px 0px;
          font-weight: 600;
          font-size: 10px;
          color: #ffffff;
        }
        .commodityLeft {
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          .packageName {
            font-weight: 600;
            font-size: 17px;
            color: #596380;
          }
          .promotionDescription {
            font-weight: 500;
            font-size: 13px;
            color: #a9adb6;
            margin-top: 2px;
          }
        }
        .commodityRight {
          .salePrice {
            display: flex;
            align-items: baseline;
            .span1 {
              font-size: 17px;
              font-weight: 500;
              color: #596380;
              margin-right: 2px;
            }
            .span2 {
              font-size: 24px;
              font-weight: 500;
              color: #596380;
            }
          }
          .avgPrice {
            background: #e6e9f2;
            border-radius: 24px;
            padding: 3px 0px;
            font-weight: 500;
            font-size: 10px;
            color: #a9adb6;
          }
        }
      }
      .commodity_active {
        background: linear-gradient(180deg, #e0dcff 0%, #ffffff 100%);
        border: 2px solid #a092eb;
        .cornerMark {
          left: -2px;
          top: -7px;
        }
        .peculiarMark {
          left: -2px;
          top: -7px;
        }
        .commodityLeft {
          .packageName {
            color: #8572eb;
          }
          .promotionDescription {
            color: #a092eb;
          }
        }
        .commodityRight {
          .salePrice {
            .span1 {
              color: #8572eb;
            }
            .span2 {
              color: #8572eb;
            }
          }
          .avgPrice {
            background: #e9e3ff;
            color: #a092eb;
          }
        }
      }
    }
  }
  .moreBox {
    font-weight: 500;
    font-size: 15px;
    color: #a9adb6;
    padding: 5px 0;
    margin-top: 8px;
    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 15px;
        height: 15px;
        margin-left: 10px;
      }
    }
    .getBack {
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
    }
  }
}
</style>